import { Box, Link } from '@mui/material';

export interface OtherJobItemProps {
  title: string;
  href: string;
}

export const OtherJobItem = ({ title, href }: OtherJobItemProps) => {
  return (
    <Box
      mt={1}
      mb={2}
      sx={(theme) => ({
        [theme.breakpoints.up('sm')]: {
          display: 'inline-block',
          padding: theme.spacing(0, 2),
          borderLeft: `2px solid ${theme.palette.care?.grey[300]}`,
          '&:first-child': { borderLeft: 'none', paddingLeft: 0 },
        },
      })}>
      <Link
        href={href}
        underline="none"
        sx={{ fontWeight: 'bold', fontSize: (theme) => theme.typography.body2.fontSize }}>
        {title}
      </Link>
    </Box>
  );
};
